export default {
  name: "LeftPanel",
  props: ["source"],
  data: function data() {
    return {
      cards: [{
        type: "sex",
        row1: {
          label: "男性占比",
          unit: "%",
          key: "nanScore"
        },
        row2: {
          label: "女性占比",
          unit: "%",
          key: "nvScore"
        }
      }, {
        type: "report",
        row1: {
          label: "门诊评估量表",
          unit: "张",
          key: "mzScale"
        },
        row2: {
          label: "病房评估量表",
          unit: "张",
          key: "bfScale"
        }
      }, {
        type: "error",
        row1: {
          label: "异常指标",
          unit: "个",
          key: "normalNum"
        },
        row2: {
          label: "异常患者",
          unit: "人",
          key: "normalPatient"
        }
      }, {
        type: "tel",
        row1: {
          label: "已电话随访",
          unit: "次",
          key: "alreadyPhone"
        },
        row2: {
          label: "待电话随访",
          unit: "次",
          key: "waitPhone"
        }
      }, {
        type: "access",
        row1: {
          label: "已问卷随访",
          unit: "次",
          key: "alreadyWj"
        },
        row2: {
          label: "待问卷随访",
          unit: "次",
          key: "waitWj"
        }
      }]
    };
  }
};